export const useArticlePage = async () => {
  const nuxtApp = useNuxtApp();
  const categoryEventName = 'Blog';
  const eventName = 'click_blog_category';

  const { analyticEvent, fbPixelEvent } = useAnalytic();
  const eventArticle = (article: string) => {
    analyticEvent({
      ga4ActionName: 'click_blog',
      ga4Label: article,
    });
    fbPixelEvent({
      fbCategory: 'trackCustom',
      fbEvent: 'Blog',
      fbValue: {
        label: article,
      },
    });
  };

  const { getPath, slugPageInfo, domain } = useNavigationMenu();
  const { isMainLanguage } = useLanguage();

  const {
    breadcrumbs,
    asyncCategory,
    items: articles,
    page,
    perPage,
    total,
  } = await useListApi<Article>({
    categoryApiPath: '/article-categories',
    itemPath:
      '/articles?populate=articleCategory&orderBy=createdAt&sortBy=desc',
    categoryField: 'articleCategoryId',
    componentName: 'Article',
    hasCategory: true,
    defaultPerPage: 24,
  });
  const currentCategory = computed(() => asyncCategory.value?.category);

  useCustomSeo({
    title: () => currentCategory.value?.metaTitleFront || slugPageInfo.value?.metaTitleFront,
    description: () =>
      currentCategory.value?.metaDescriptionFront ||
      slugPageInfo.value?.metaDescriptionFront ||
      slugPageInfo.value?.description,
    image: () => currentCategory.value?.ogImage?.large || slugPageInfo.value?.ogImage?.large,
    noindex: () => !isMainLanguage.value && articles.value.length === 0,
  });

  const { currentLocaleCode } = useLanguage();
  nuxtApp.runWithContext(() =>
    useSchemaOrg([
      defineWebPage({
        '@type': 'CollectionPage',
        name: currentCategory.value?.metaTitleFront || slugPageInfo.value?.metaTitleFront,
        '@id': `${domain.value}${getPath({ componentName: 'Article' })}#webpage`,
        url: `${domain.value}${getPath({ componentName: 'Article' })}`,
        inLanguage: currentLocaleCode.value,
        isPartOf: { '@id': `${domain.value}/#website` },
        publisher: { '@id': `${domain.value}/#organization` },
        mainEntity: articles.value.map((article) => ({
          '@type': 'Article',
          headline: article.title,
          description: article.shortDescription || '',
          url: `${domain.value}${getPath({ componentName: 'Article', slug: article.slug })}`,
          image: article.imageCover?.large || '',
          datePublished: article.publishedAt || '',
        })),
      }),
      defineItemList({
        '@id': `${domain.value}/article#category-list`,
        itemListElement: asyncCategory.value?.categoryButtonItems?.map(
          (cat, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: cat.title,
            url: `${domain.value}${cat.path}`,
          }),
        ),
      }),
    ]),
  );

  return {
    // Data
    categoryEventName,
    eventName,
    breadcrumbs,
    asyncCategory,
    articles,
    page,
    perPage,
    total,

    // Methods
    eventArticle,
    getPath,
  };
};
